import { CoreAccount } from './core-account.model';
import { CoreUserState } from './core-user-state.model';

export interface CoreUser {
  id?: string;
  email: string;
  emailVerified: boolean;
  termsAndConditionsAccepted: boolean;
  lastLoginDate: Date;
  lastLoginIp: string;
  accounts: CoreAccount[];
  userState: CoreUserState;
}
